var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.events),function(event,index){return _c('li',{key:index},[_c('ClientEventProcedureItem',{attrs:{"event":event}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }